import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

interface WalletItem {
  crypto: string;
  amount: number;
  value?: number;
}

interface WalletCardProps {
  wallets: WalletItem[];
}

export function WalletCard({ wallets }: WalletCardProps) {
  const totalValue = wallets.reduce(
    (sum, w) => sum + (w.value || w.amount),
    0
  );

  return (
    <Card className="p-6">
      <h2 className="text-xl font-bold mb-4">Il Tuo Portafoglio</h2>
      <div className="mb-6">
        <p className="text-sm text-primary/60">Valore Totale</p>
        <p className="text-3xl font-bold">
          ${totalValue.toFixed(2)}
        </p>
      </div>

      <div className="space-y-3">
        {wallets.map((wallet) => (
          <div
            key={wallet.crypto}
            className="flex items-center justify-between p-3 bg-primary/5 rounded-lg"
          >
            <div>
              <p className="font-medium">{wallet.crypto}</p>
              <p className="text-sm text-primary/60">{wallet.amount.toFixed(8)}</p>
            </div>
            <Badge variant="secondary">
              ${(wallet.value || wallet.amount).toFixed(2)}
            </Badge>
          </div>
        ))}
      </div>
    </Card>
  );
}
